export default __webpack_public_path__ + "static/media/budget_2.33128746.jpg";